/** `client.deliveries` (car-doctor#131): business:write staff only. */
export class DeliveriesClient {
    request;
    constructor(request) {
        this.request = request;
    }
    base(slug) {
        return `/v1/sites/${encodeURIComponent(slug)}/deliveries`;
    }
    /**
     * Text or email the customer a link to a stored PDF. Answers 202; a provider
     * failure comes back as status "failed" (not an error). 409 when the number
     * replied STOP, 429 on too many sends, 400 for a bad recipient or file.
     */
    create(slug, input) {
        return this.request("POST", this.base(slug), input, true);
    }
    /** Deliveries for one report or repair order, newest first. */
    async list(slug, subject) {
        const q = new URLSearchParams({ subjectType: subject.subjectType, subjectId: subject.subjectId });
        const res = await this.request("GET", `${this.base(slug)}?${q.toString()}`, undefined, true);
        return res.deliveries;
    }
}
//# sourceMappingURL=deliveries.js.map